interface RadioGroupProps {
  options: { key: string; label: string }[];
  value: string;
  onChange: (val: string) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  value,
  onChange,
}) => (
  <div className="flex flex-wrap items-center gap-6 font-nunito">
    {options.map(option => (
      <label
        key={option.key}
        className={`flex cursor-pointer items-center gap-2 font-nunito text-[16px] font-semibold leading-[30px] [font-feature-settings:'liga_off','clig_off'] ${
          value === option.key
            ? "font-extrabold text-[#000000]"
            : "text-[#707070]"
        }`}
      >
        <input
          type="radio"
          name={option.key}
          value={option.key}
          checked={value === option.key}
          onChange={e => onChange(e.target.value)}
          className="h-4 w-4 accent-[#000000]"
        />
        {option.label}
      </label>
    ))}
  </div>
);

export default RadioGroup;
